layout = {};
o2.xApplication = o2.xApplication || {};
o2.widget = o2.widget || {};
o2.widget.css = o2.widget.css || {};
o2.xDesktop = o2.xDesktop || {};
o2.xDesktop.$all=true;
o2.xDesktop.Common=true;
